import React, { ReactElement } from 'react'
import { CutToSizeItems } from './types/models'
import trashCan from '../../../assets/images/fa/trash.svg'

type Props = {
  cutToSizeItems: CutToSizeItems[]
  setCutToSizeItems: (value: CutToSizeItems[]) => void
}

const CutToSizeCrossSellSummary = ({ cutToSizeItems, setCutToSizeItems }: Props): ReactElement => {
  const removeSummaryItem = (index):void => {
    const items = cutToSizeItems.filter(function (item, i) {
      return i !== index
    })
    setCutToSizeItems(items.reverse())
  }

  if (cutToSizeItems.length > 0) {
    return (
      <>
        <div className="cutToSize-crossSellSummary-repeatNote new">
          Repeat to add more lengths
        </div>
        <div className="cutToSize-crossSellSummary-container">
          <p className="cutToSize-crossSellSummary-note">Items to be added to your basket:</p>
          { cutToSizeItems.map((item, index) => {
            return (
              <div className="cutToSize-innerSummary" id={index.toString()}
              key={`${item.product}-${item.length}-${item.dimension}`}
              data-product={item.product}
              data-length={item.length}
              data-width={item.width}
              data-quantity={item.quantity}
              data-valid={1}
              data-cansubmit={true}>
                <div className='cutToSize-CrossSell-details'><p className="cutToSize-CrossSell-subHeading">Length:</p> <br/>{item.length}mm</div>
                <div className='cutToSize-CrossSell-details'><p className="cutToSize-CrossSell-subHeading">Size:</p> <br/>{item.dimension}</div>
                <div className='cutToSize-CrossSell-details'><p className="cutToSize-CrossSell-subHeading">Quantity:</p> <br/>{item.quantity}</div>
                <div className='cutToSize-CrossSell-details'><p className="cutToSize-CrossSell-subHeading">Price:</p> <br/>£{item.price}</div>
                <div className='crossSellSummary-removalContainer'>
                  <button className='crossSellSummary-remove' onClick={() => removeSummaryItem(index)}><img src={trashCan} width='15px' height='18px' className='crossSell-add-imageContainer'/></button>
                </div>
              </div>
            )
          })}
        </div>
      </>
    )
  }
}

export default CutToSizeCrossSellSummary
